import { createElementVNode as _createElementVNode, renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["id"]
const _hoisted_2 = /*#__PURE__*/_createElementVNode("defs", null, [
  /*#__PURE__*/_createElementVNode("filter", { id: "inset-shadow" }, [
    /*#__PURE__*/_createElementVNode("feColorMatrix", {
      type: "matrix",
      values: "0 0 0 0 0\n              0 0 0 0 0\n              0 0 0 0 0\n              0 0 10 0 0"
    }),
    /*#__PURE__*/_createElementVNode("feGaussianBlur", { stdDeviation: "3" }),
    /*#__PURE__*/_createElementVNode("feComposite", {
      operator: "in",
      in2: "SourceGraphic"
    }),
    /*#__PURE__*/_createElementVNode("feDiffuseLighting", {
      surfaceScale: "200",
      diffuseConstant: "1",
      kernelUnitLength: "1",
      "lighting-color": "white",
      result: "lightmap"
    }, [
      /*#__PURE__*/_createElementVNode("fePointLight", {
        x: "10",
        y: "0",
        z: "100"
      })
    ]),
    /*#__PURE__*/_createElementVNode("feGaussianBlur", { stdDeviation: "10" }),
    /*#__PURE__*/_createElementVNode("feColorMatrix", { type: "luminanceToAlpha" }),
    /*#__PURE__*/_createElementVNode("feComposite", {
      operator: "in",
      in2: "SourceGraphic"
    }),
    /*#__PURE__*/_createElementVNode("feComposite", {
      operator: "over",
      in2: "SourceGraphic"
    })
  ])
], -1 /* HOISTED */)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", { id: $props.id }, [
    _hoisted_2,
    _renderSlot(_ctx.$slots, "default")
  ], 8 /* PROPS */, _hoisted_1))
}